import debug from 'debug';

export const pluginID = 'WBUPlugin';

export const wbuLog = debug(pluginID);
